import { render, staticRenderFns } from "./xitongduijie-shuguang.vue?vue&type=template&id=cac855da&scoped=true&"
import script from "./xitongduijie-shuguang.vue?vue&type=script&lang=ts&"
export * from "./xitongduijie-shuguang.vue?vue&type=script&lang=ts&"
import style0 from "./xitongduijie-shuguang.vue?vue&type=style&index=0&id=cac855da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac855da",
  null
  
)

export default component.exports